jQuery(document).ready(function($) {

    $(".logos-list-carousel").slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
            {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: false,
                arrows: true
            }
            },
            {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
            }
        ]
        });

    // Homepage carousel read more
    $('.read-more-toggle').on('click', function(e) {
      e.preventDefault();

      var $this = $(this);
      var $parent = $this.closest('.read-more-content');
      var $longText = $parent.find('.long-text');

      if ($longText.is(':visible')) {
        $longText.hide();
        $this.text(' Read more');
      } else {
        $longText.show();
        $this.text(' Read less');
      }
    });

    /* Collection page read more */
    var $desc = $("#collection-description");
    if (!$desc.length) return;

    if ($(window).width() <= 767) {
        var fullHTML = $desc.html().trim();

        $desc.html(
            '<div class="short-text">' + fullHTML + '</div>' +
            '<div class="full-text" style="display:none;">' + fullHTML + '</div>' +
            '<a href="#" class="read-more">Read more</a>' +
            '<a href="#" class="read-less" style="display:none;">Read less</a>'
        );

        // Toggle logic
        $desc.on("click", ".read-more", function(e) {
            e.preventDefault();
            $desc.find(".short-text").hide();
            $desc.find(".full-text").slideDown();
            $(this).hide();
            $desc.find(".read-less").show();
        });

        $desc.on("click", ".read-less", function(e) {
            e.preventDefault();
            $desc.find(".full-text").slideUp(function() {
                $desc.find(".short-text").show();
            });
            $(this).hide();
            $desc.find(".read-more").show();
        });
    }

});